class RequestQueueUtil {
    static addQueueKey(queue, key) {

        let newRequestQueue = [];
        if (queue !== undefined){
            newRequestQueue = queue.slice();
        }

        if (!newRequestQueue.indexOf(key) > -1) {
            newRequestQueue.push(key);
        }

        return newRequestQueue;
    }

    static removeQueueKey(queue, key) {

        if (queue === undefined){
            return [];
        }

        let newRequestQueue = queue.slice();
        let indexOfKey = queue.indexOf(key);
        newRequestQueue.splice(indexOfKey, 1);
        return newRequestQueue;
    }
}

export default RequestQueueUtil;
